import React from 'react';
import styles from './TableContent.module.scss';
import PropTypes from 'prop-types';
import { Table, } from 'antd';
import { tooltipStyle, tooltip, } from '@/components/TableCell';
import moment from 'moment';


class ContractTable extends React.PureComponent {
    columns = () => [
        {
            title: '模板名称',
            dataIndex: 'name',
            key: 'name',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '版本号',
            dataIndex: 'version',
            key: 'version',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '提交时间',
            dataIndex: 'gmtCreateM',
            key: 'gmtCreateM',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'isDeleteValue',
            key: 'isDeleteValue',
            align: 'center',
            width: '9%',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '10%',
            render: (id, record) => this.tableAction(id, record)
        }
    ];

    //操作
    tableAction = (id, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(id, 'pdf', record)}>查看模板</div>
                <div className={styles.item} onClick={() => tableAction(id, 'temp')}>已签署</div>
            </div >
        );
    };

    // 解析表格数据
    _takeDataSource = (data) => {
        // 解析表格数据，使符合columns格式要求
        return data.map(item => {
            item.gmtCreateM = item.gmtCreate ? moment(item.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '';
            return item;
        });
    }


    render() {
        const { renderData, } = this.props;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this.columns()}
                    dataSource={this._takeDataSource(renderData)}
                    pagination={false}
                    scroll={{ x: 'max-content', y: true }}
                />
            </div>
        );
    }
}

ContractTable.propTypes = {
    renderData: PropTypes.array, // 渲染数据源(双向绑定)
    tableAction: PropTypes.func, // 对表格的操作
};

export default ContractTable;